import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0ce988a8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0ce988a8&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=0ce988a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce988a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ce988a8')) {
      api.createRecord('0ce988a8', component.options)
    } else {
      api.reload('0ce988a8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0ce988a8&scoped=true", function () {
      api.rerender('0ce988a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/toursCombine/tcSetting/index.vue"
export default component.exports